import { RootStore, PagedList } from ".";
import { observable, action, runInAction } from "mobx";
import { formatDateJson } from "../common/Formatting";
import { fetchWrapper } from "../common/Fetch";
import { SuccessableResult } from "../common/BaseClasses";
import { NotificationLevel } from "./NotificationStore";

export interface RejectionPosition {
    id: number;
    isReaded: boolean;
    orderGuid: string;
    orderNumber: number;
    customerName: number;
    dateCreate: Date;
    brand: string;
    article: string;
    description: string;
    managerName: string;
    supplierName: string;
    deliveryTimeString: string;
    statusName: string;
    statusRejected: string;
    clientName: string;
    rejectCount: number;
    count: number;
    costSale: number;
    isAllowDiscountRefund: boolean | null;
}

export class RejectionsStore {
    _rootStore: RootStore;

    @observable rejections: RejectionPosition[] = [];
    @observable currentPage = 1;
    @observable totalOrdersCount = 1;
    @observable newRejectionsCount = 0;


    constructor(rootStore: RootStore) {
        this._rootStore = rootStore;
    }

    @action
    loadRejections(managerIds: string[], customerId: string, page = 1, source?: string, dateFrom?: Date, dateTo?: Date) {
        this.rejections = [];
        const managerIdsParam = managerIds.length <= 0 ? "" : "&managerIds=" + managerIds.join("&managerIds=");
        customerId = customerId == "-1" ? "" : customerId;
        const dateFromStr = dateFrom == undefined ? '' : formatDateJson(dateFrom);
        const dateToStr = dateTo == undefined ? '' : formatDateJson(dateTo);
        source = source || "";

        fetchWrapper(`api/Rejections/list/${page}?customerId=${customerId}${managerIdsParam}&source=${source}&dateFrom=${dateFromStr}&dateTo=${dateToStr}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }, this._rootStore.commonStore)
            .then(res => res.json() as Promise<PagedList<RejectionPosition>>)
            .then(result => {
                runInAction("fetch complete loadOrders", () => {
                    this.currentPage = page;
                    this.totalOrdersCount = result.totalItemCount;
                    this.rejections = result.items;
                });
            })
            .catch(res => {
                console.log(res);
            });
    }
    @action
    readRejections(positionsIds: number[]) {
        fetchWrapper(`api/Rejections/setasreaded`, {
            method: 'POST',
            body: JSON.stringify([...positionsIds]),
            headers: {
                'Content-Type': 'application/json'
            }
        }, this._rootStore.commonStore)
            .then(res => res.json() as Promise<SuccessableResult<any>>)
            .then(result => {
                runInAction("fetch complete readRejections", () => {
                    if (result.isSuccess) {
                        this.loadNewRejectionsCount();
                        this.rejections = this.rejections.map(w => Object.assign({}, w, { isReaded: w.isReaded || positionsIds.indexOf(w.id) > -1 }));
                    }
                    else
                        this._rootStore.notificationStore.addNotification(result.errorMessage, NotificationLevel.error);
                });
            })
            .catch(res => {
                console.log(res);
            });
    }
    @action
    loadNewRejectionsCount() {
        if (this._rootStore.authStore.isAuthenticated && (this._rootStore.authStore.isCallCentre || this._rootStore.authStore.isFranchise))
            fetchWrapper(`api/Rejections/newcount`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            }, this._rootStore.commonStore, false)
                .then(res => res.json() as Promise<number>)
                .then(result => {
                    runInAction("fetch complete loadNewRejectionsCount", () => {
                        this.newRejectionsCount = result;
                    });
                })
                .catch(res => {
                    console.log(res);
                });
    }
}